import type { LayersList } from '@deck.gl/core';
import type { TileLayerProps } from '@deck.gl/geo-layers';
import type { Tile2DHeader } from '@deck.gl/geo-layers/dist/tileset-2d/tile-2d-header';
import { BitmapLayer } from '@deck.gl/layers';
import type { BitmapBoundingBox, BitmapLayerProps } from '@deck.gl/layers';

import { geoBbox } from './tileBbox';

type BitmapTileSubLayerProps<DataT> = Omit<TileLayerProps<DataT>, 'data'> & {
  id: string;
  data: DataT;
  tile: Tile2DHeader<DataT>;
};

type BitmapSubLayerOverrides = Omit<
  Partial<BitmapLayerProps>,
  'data' | 'image' | 'bounds'
>;

export function renderBitmapTileSubLayer<DataT>(
  props: BitmapTileSubLayerProps<DataT>,
  overrides?: BitmapSubLayerOverrides
): LayersList {
  const { data, tile, ...parentProps } = props;
  const { west, south, east, north } = geoBbox(tile.bbox);
  const bounds: BitmapBoundingBox = [west, south, east, north];
  return [
    new BitmapLayer(parentProps, {
      image: data as NonNullable<BitmapLayerProps['image']>,
      bounds,
      ...overrides,
    }),
  ];
}
